import { InheritedIraState as _InheritedIraState } from '@interfaces/state/inherited-ira/inherited-ira.interface';
import { Action, createReducer, on } from '@ngrx/store';
import { UpdateInheritedIraDecedentInfo } from '@store/actions/inherited-ira/inherited-ira.actions';

export interface InheritedIraState extends _InheritedIraState {}

export const initialState: InheritedIraState = {
  isPreviouslyInherited: null,
  isRothIra: null,
  decedentName: '',
};

const inheritedIraReducer = createReducer(
  initialState,
  on(UpdateInheritedIraDecedentInfo, (state, { payload }) => ({
    ...payload,
  })),
);

export function reducer(state: InheritedIraState | undefined, action: Action) {
  return inheritedIraReducer(state, action);
}
